module.exports = __webpack_public_path__ + "static/media/train.ff6436bc.svg";